import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter
} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Utils} from "@amlCore/utils";
import {InternalService} from "../internal.service";
import {DictionaryService} from "@amlCore/services";
import {ClientTypeEnum} from "@amlCore/enums";
import {InternalModel} from "../../../model";
import {IDictItemType} from "@amlCore/interfaces";
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-internal-view',
  templateUrl: './internalView.component.html'
})
export class InternalViewComponent implements OnInit {
  item: InternalModel;
  clientTypeEnum = ClientTypeEnum;
  @Input() id = null;
  @Input() isModal = false;
  @Output() startLoading: any = new EventEmitter<boolean>();
  @Output() finishLoading: any = new EventEmitter<boolean>();
  docTypeList: IDictItemType[] = [];
  opfInbULList: IDictItemType[] = [];
  constructor(private dictSrv: DictionaryService, private internalService: InternalService,
              private route: ActivatedRoute,
              private _activeModal: NgbActiveModal) {
  }

  ngOnInit() {
    if (this.id) {
      this.startLoading.emit(true);
      this.startLoading.complete();
      this.loadInternal(this.id);
    } else {
      this.route.params.subscribe(params => {
        Utils.scrollTopSmooth();
        this.id = params.id;
        this.loadInternal(this.id);
      });
    }
    this.dictSrv.getRemoteData('documenttypecodes').then((result) => {
      this.docTypeList = result;
    });
    this.dictSrv.getRemoteData("orgforminboul").then((result) => {
      this.opfInbULList = result;
    });
  }

  loadInternal(id: string) {
    this.internalService.getInternal(id).subscribe((data) => {
      this.item = data;
      this.finishLoading.emit(false);
      this.finishLoading.complete();
    });
  }

  closeModal() {
    this._activeModal.dismiss(false);
  }

  getClientTypeName(code: string) {
    return this.dictSrv.getStaticDataValue('clientType', code);
  }

  getDocTypeName(code: string){
    const findObj = this.docTypeList.find(item => item['code'] === code);
    return findObj?findObj['name']:code;
  }

  getOpfName(code: string){
    const findObj = this.opfInbULList.find(item => item['code'] === code);
    return findObj ? findObj['name'] : code;
  }

}
